// @flow
import React from 'react';
import { H4 } from '@finect/tabular-core/Headings';
import { Small } from '@finect/tabular-core/Small';
import { AppLink } from '@finect/tabular-core/AppLink';
import { EntityCard } from '@finect/tabular-components/EntityCard';
import { INDEX_QUESTIONS } from '@finect/tabular-components/Questions';
import { slugify } from '@finect/front-utils/slugify';
import { timeSince } from '@finect/front-utils/timeSince';
import { QuestionTitle, Tags, Tag, Toolbar } from '../';
import type { QuestionType, UserType } from '../../types';
import { QuestionLink, QuestionSummary } from './partials';

type Props = {
  question: QuestionType,
  blockVote?: boolean,
  user: UserType,
  voted: boolean,
  following: boolean,
  handleLike: Function,
  handleFollow: Function,
  openOverlay: Function,
  backText?: string
};

export const QuestionPreview = ({
  question,
  blockVote,
  user,
  voted,
  // following,
  handleLike,
  // handleFollow,
  backText
}: Props) => {
  // const handleVote = () => {
  // if (user.isLoggedIn) return vote(question.id);
  // const blob = {
  // copy: 'Accede a Finect para realizar esta acción.',
  // action: 'like',
  // target: {
  // id: question.id,
  // type: 'question'
  // }
  // };
  // openOverlay(blob);
  // };
  //
  // const handleFollow = () => {
  // if (user.isLoggedIn) return follow(question.id);
  // const blob = {
  // copy: 'Accede a Finect para guardar esta pregunta.',
  // action: 'subscribe',
  // target: {
  // id: question.id,
  // type: 'question'
  // }
  // };
  // openOverlay(blob);
  // };

  const authors = question.authors;
  const author = authors[question.author];

  const { features = [] } = author;

  const nameComponent = features.includes('profile') ? (
    <AppLink href={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}${author.url}`}>
      {author.name ? author.name : author.alias}
    </AppLink>
  ) : (
    <span>{author.name ? author.name : author.alias}</span>
  );
  const questionPath = `/preguntas/${question.id}/${slugify(question.title)}`;

  const selectedAnswer = Boolean((question.answers || []).find(quest => quest.selected || false));
  return (
    <QuestionSummary>
      <Tags isPreview>
        {question.tags.map(tag => (
          <EntityCard
            key={tag.id}
            type="tag"
            entity={{
              id: tag.id,
              name: tag.name,
              alias: slugify(tag.name)
            }}
            loggedIn={user.isLoggedIn}
          >
            <Tag followed={tag.following} tag={tag}>
              {tag.name}
            </Tag>
          </EntityCard>
        ))}
      </Tags>
      <Small>
        {!blockVote ? (
          <EntityCard
            type="profile"
            entity={{
              id: author.id,
              name: author.name || author.alias,
              alias: author.alias,
              icon: author.image,
              company: author.adviserAt && author.adviserAt.name,
              adviser: author.type === 'adviser',
              verified: author.type === 'adviser' || author.type === 'company'
            }}
            loggedIn={user.isLoggedIn}
            arrowPosition={9}
          >
            {nameComponent}
          </EntityCard>
        ) :
          nameComponent
        }{' '}
        {timeSince(new Date(question.created))} pregunta:
      </Small>
      <QuestionTitle isPreview>
        <H4>
          <QuestionLink
            to={{
              pathname: questionPath,
              state: { fromApp: true, backText }
            }}
            rel={!INDEX_QUESTIONS.includes(Number(question.id)) ? 'nofollow' : undefined}
          >
            {question.title.length > 120 ? question.title.slice(0, 120) : question.title}
          </QuestionLink>
        </H4>
      </QuestionTitle>
      <Toolbar
        like={{
          qty: question.stats.votes,
          action: handleLike,
          done: voted,
          disable: blockVote ? 'No puedes realizar esta acción sobre tus preguntas' : ''
        }}
        respond={{
          qty: question.stats.answers,
          id: question.id,
          solved: selectedAnswer,
          path: questionPath
        }}
        // save={{
        //   action: handleFollow,
        //   done: following
        // }}
        share={{
          title: question.title,
          path: questionPath
        }}
      />
    </QuestionSummary>
  );
};
